import { Text, TextLink } from 'braid-design-system';

import { BASE_URL } from 'src/constants/urls';
import type { User } from 'src/graphql/generated';
import { useConfig } from 'src/modules/ConfigProvider';

export const UserName = ({ firstName, lastName, id }: User) => {
  const { urlResolver } = useConfig();
  return (
    <Text weight="strong">
      <TextLink
        weight="weak"
        href={urlResolver({ path: `/${BASE_URL}/edit/${id}` })}
        data={{
          testid: 'user-name',
          'dd-privacy': 'mask',
          'hj-masked': true,
        }}
      >
        {firstName} {lastName}
      </TextLink>
    </Text>
  );
};
